<template>
    <tbody class="step">
        <tr v-for="(aa, aaIndex) in value.ApprovalAuthorities" :key="value.Id + aa.Id">
            <td class="text-center step-index" :rowspan="value.ApprovalAuthorities.length + 1" v-if="aaIndex === 0">
                <h2 style="margin-bottom:2px; line-height:1rem">{{parseInt(index, 10) + 1}}.</h2>
                <div>{{translate('stepEditorStep.step')}}</div>
                <div class="step-connect-line"></div>
            </td>
            <td class="step-index-seperator aa" :rowspan="value.ApprovalAuthorities.length + 1" v-if="aaIndex === 0">
                <button type="button" v-if="editable && aaIndex == 0" @click="$emit('removestep', value)" class="remove-step remove-square text-danger"></button>
            </td>
            <td class="aa">
                <approval-authority-info v-if="aa" :user-list="filteredUserList" v-model="value.ApprovalAuthorities[aaIndex]" @remove="removeApprovalAuthority($event)" :editable="editable"></approval-authority-info>
                <div v-else class="text-danger">{{translate('stepEditorStep.invalidApprover')}}</div>
            </td>
        </tr>
        <tr>
            <td colspan="2" class="aa" style="padding-left:16px">
                <small style="padding:4px 16px 0 0;" v-if="value.IsCompleted" class="text-success float-right">{{translate('stepEditorStep.stepCompleted')}}</small>

                {{translate('stepEditorStep.inThisStep')}}
                <span v-if="value.ApprovalAuthorities.length <= 1">{{translate('stepEditorStep.users')}}&nbsp;</span>
                
                <template v-else>
                    <select v-model="value.Condition" class="condition" v-if="editable">
                        <option value="All">{{translate('stepEditorStep.allUsers')}}</option>
                        <option value="Any">{{translate('stepEditorStep.onlyOne')}}</option>
                    </select>
                    <span v-else style="text-decoration:underline;">{{ value.Condition == 'All' ? translate('stepEditorStep.allUsers') : translate('stepEditorStep.onlyOne') }}&nbsp;</span>
                </template>
                <select v-model="value.Action" @change="onStepActionChange(value)" class="condition" v-if="editable">
                    <option value="Sign">{{translate('stepEditorStep.needSignature')}}</option>
                    <option value="Approve">{{translate('stepEditorStep.approvalEnough')}}</option>
                </select>
                <span v-else style="text-decoration:underline;">{{ value.Action == 'Sign' ? translate('stepEditorStep.needSignature') : translate('stepEditorStep.approvalEnough') }}</span>
            </td>
        </tr>
        <tr v-if="!value.ApprovalAuthorities || value.ApprovalAuthorities.length < 1">
            <td colspan="3">
                <div>{{translate('stepEditorStep.noApproverWarn')}}</div>
            </td>
        </tr>
        <tr class="step-row-seperator">
            <td colspan="3" style="padding-top:0;">
                <button v-if="editable" type="button" @click="createApprovalAuthority" class="float-right btn btn-link btn-sm">{{translate('stepEditorStep.addUserToStep:'+ (parseInt(index, 10) + 1))}}</button>
                <approval-authority-editor v-if="newApprovalAuthority" v-model="newApprovalAuthority" :user-list="userList" @cancel="newApprovalAuthority = null" @apply="addApprovalAuthority"/>
            </td>
        </tr>
    </tbody>
</template>
<script>
import ObjectId from '../ObjectId.js'
import approvalAuthorityInfo from '../components/ApprovalAuthorityInfo.vue';
import approvalAuthorityEditor from '../components/ApprovalAuthorityEditor.vue';

export default {
    components: {
        approvalAuthorityInfo,
        approvalAuthorityEditor
    },
    props: {
        index: Number,
        value: Object,  // Step
        userList: {
            type: Array,
            required: true
        },
        editable: Boolean
    },
    data() {
        return {
            newApprovalAuthority: null
        }
    },
    computed: {
        filteredUserList(){
            if(!this.userList)
                return  [];

            var requiredAuth = {
                "Approve": "Approver",
                "Sign": "Signer"
            }[this.value.Action]

            console.log('filteredUserList');
            return this.userList.filter(x => x.Authorities.some(y => y == requiredAuth));   
        }
    },
    methods: {
        createApprovalAuthority(){
            this.newApprovalAuthority = { Kind : 'ApprovalAuthorityUser', UserId: null, Id: ObjectId.NewId() }
        },
        addApprovalAuthority(aa){
            //var aa = { Kind : "ApprovalAuthorityUser", UserId: null, Id: ObjectId.NewId() };
            this.value.ApprovalAuthorities.push(aa);
            this.newApprovalAuthority = null;
            this.$emit('input', this.value);
        },
        removeApprovalAuthority(aa) {
            if(this.value.ApprovalAuthorities.length == 1) {
                alert(this.translate('errors.atLeastOneApprover'));
                return;
            }
            this.value.ApprovalAuthorities = this.value.ApprovalAuthorities.filter(x => x != aa);
            this.$emit('input', this.value);
        },
    }
}
</script>

<style scoped>
.remove-step {
    display: none;
    position: relative;
    margin-left: -28px;
    cursor: pointer;
    border:0;
    background-color: transparent;
    height: 20px;
    padding: 0;
    width: 20px;
    outline: none;
}

.step-connect-line {
    position: relative;
    border-top: 1px solid rgb(204, 204, 204);
    width: 20px;
    float: right;
    margin-right: -12px;
    margin-top: -23px;
}

.step td.aa {
    transition: background-color 0.3s;
}

.step:hover .remove-step {
    display:block;
}

td.aa {
    padding: 0 0 8px 0;
}

.step:hover td.aa {
    background: #F7F7F7;
}

.step:hover .step-index {
    color: #007bff;
}

.step-index {
    width:100px;
    vertical-align: middle;
}

.step-index-seperator {
    width:15px;
    border: 1px solid #CCC;
    border-right: 0;
    border-radius: 6px;
}

.step-row-seperator {
    padding-top:0;
}
.step-row-seperator button {
    padding: 0;
}

select.condition:active {
    outline: none;
    border: 0px;

}

select.condition {
    border:0px;
    border-radius: 4px;
    background: transparent;
    text-decoration: underline;
    cursor: pointer;
    outline: none;
}

select.condition:hover:enabled {
    /* border-color: #DDD; */
    background: #FFF;
}

select.condition:disabled {
    color:#000 !important;
}
</style>